var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormRender',{attrs:{"form":_vm.form,"Service":_vm.Service}},[_c('FormInput',{attrs:{"field":_vm.formFields.user_id},model:{value:(_vm.form.user_id),callback:function ($$v) {_vm.$set(_vm.form, "user_id", $$v)},expression:"form.user_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }